import { ReactElement } from 'react';

import { useDialogState } from '../../../../../../../../../common/hooks/useDialogState';
import { IndicationStatus } from '../../../../../../../../../graphql';
import { useIndicationActivitySalesAndTradingContext } from '../../../../../context/IndicationActivitySalesAndTradingContext';
import { type Props as ReadButtonProps } from '../../../common/indication-section-read-view/ReadButtons';
import CancelCoveredIndicationConfirmDialog from '../cancel-covered-indication-confirm-dialog/CancelCoveredIndicationConfirmDialog';

export const useCreateSalesAndTradingDuplicateReadButtonProps = (): ReadButtonProps & {
  duplicateReadButtonDialogs: ReactElement[];
} => {
  const {
    offeringId,
    access: { canUpdateCoveredIndication },
    complianceWarning: { hasComplianceWarning, canByPassComplianceWarning },
    coveredIndication: indication,
  } = useIndicationActivitySalesAndTradingContext();

  const {
    isOpen: isCancelDialogOpen,
    onOpen: openCancelDialog,
    onClose: closeCancelDialog,
  } = useDialogState();

  return {
    baseButtonAccess: canUpdateCoveredIndication,
    isVisible: {
      edit: false,
      pass: false,
      reactivate: false,
      cancel:
        indication?.status !== IndicationStatus.Cancelled &&
        (canByPassComplianceWarning || !hasComplianceWarning),
    },
    menuItemProps: {
      cancel: {
        onClick: openCancelDialog,
      },
    },
    duplicateReadButtonDialogs: [
      <CancelCoveredIndicationConfirmDialog
        indicationId={indication!.id}
        offeringId={offeringId}
        isOpen={isCancelDialogOpen}
        onClose={closeCancelDialog}
      />,
    ],
  };
};
